import { ref } from 'vue'

export type ThemeType = 'care' | 'talent'

const currentTheme = ref<ThemeType | null>(null)

export function useTheme() {
    const applyTheme = (theme: ThemeType) => {
        // Remove all theme classes
        document.documentElement.classList.remove('theme-care', 'theme-talent')

        // Apply new theme class
        document.documentElement.classList.add(`theme-${theme}`)

        // Store current theme
        currentTheme.value = theme
    }

    const getCurrentTheme = () => currentTheme.value

    return {
        applyTheme,
        getCurrentTheme,
        currentTheme,
    }
}
